import { Component, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { EmployerUserModalComponent } from '@app/components/employer-user-modal/employer-user-modal.component';
import { profile_access_module } from '@app/config/role-name.enum';
import { path_module_admin, path_module_employer, path_module_public } from '@app/models/routes.name';
import { InjectorModalService } from '@app/services/injectorModal.service';
import { ScriptService } from '@app/services/script.service';
import { UserService } from '@app/services/user.service';


@Component({
  selector: 'header-style-menu-lateral',
  templateUrl: './header-style-menu-lateral.component.html',
  styleUrls: ['./header-style-menu-lateral.component.css']
})
export class HeaderStyleMenuLateralComponent {

  public path_module_employer = path_module_employer;
  public path_module_public = path_module_public;
  public path_module_admin = path_module_admin;

  constructor(
    private router: Router,
    private scriptService: ScriptService,
    public userService: UserService,
    private injectorModalService: InjectorModalService) {

  }

  onClickToogleMenu(event: MouseEvent) {
    event.preventDefault();
    this.scriptService.lateralMenubarTogglerControl();
  }

  onClickEditUser(event: MouseEvent) {
    event.preventDefault();

    if (this.userService.hasAccessToModule(profile_access_module.employer_user))
    {
      this.injectorModalService.openModal();
      return;
    }

    this.router.navigate([path_module_employer.module, path_module_employer.users]);
  }
} 